
import Articles from "~/assets/blog.json";

export default {
  data() {
    return {
      path: this.$route.path,
    };
  },

  computed: {
    articles() {
      return Articles.filter(
        (x) => "/blog/" + x.categorySlug + "/" === this.path
      );
    },
  },
};
